import { lazyLoad } from 'utils/loadable';

export const TaskOperationsPageLoadable = lazyLoad(
  () => import('./TaskOperationsPage'),
  module => module.TaskOperationsPage,
);
